import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
//
import { dispatch } from "../store";
//
import configData from "../../config.json";
//
import { languageCodes } from "../../utils/languageCodes";
// ----------------------------------------------------------------------

const { BRAND } = configData;

const initialState = {
  isLoading: false,
  error: null,
  data: null,
};

const slice = createSlice({
  name: "sendLinkLocation",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // SUCCESS
    sendLinkLocationSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function sendLinkLocation(payload) {
  const { id, lat, lng } = payload || {};
  const queryParams = { id, lat, lng };
  const { width, height } = window.screen || {};
  const languageCode =
    navigator.languages && navigator.languages.length
      ? navigator.languages[0]
      : navigator.language;
  const language = languageCodes[languageCode?.substring(0, 2)] || languageCode;
  const queryString = new URLSearchParams(queryParams).toString();

  const url = `/set/link-location?${queryString}`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      "device-size": `${width}&${height}`,
      "user-language": `${language}`,
      brand: BRAND,
    },
  };
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url, config);
      dispatch(slice.actions.sendLinkLocationSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
